import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import * as route from '../../constants/app_routes';
import logo from '../../assets/hinchlogo.png';
import {Dropdown, Icon, Menu,Label,Message} from 'semantic-ui-react';
import AuthConnector from "../../containers/auth_container";
import ListingContainer from "../../containers/listing_container";
import {
    ADMIN_API_URL,
    AGENT_API_URL,
    CLERK_API_URL,
    INSPECTION_API_URL,
    PROPERTY_API_URL,
    REPORT_ACTIONS_API_URL,
    CUSTOMER_SERVICE_API_URL,
    PROPERTY_VISIT_API_URL
} from '../../constants/api_routes';
import FilterAttributes from "../../containers/filter_container";
import InspectionContainer from "../../containers/inspection_container";
import DashboardContainer from "../../containers/dashboard_container";
import moment from "moment"

class Header extends Component {
    onRouteChange = (start,end,inspectionIds) => {
        if (this.apiRoutes[this.props.location.pathname]) {
            this.apiRoutes[this.props.location.pathname](start,end,inspectionIds);
        }
    };
    state = {activeRoute: 'dashboard'};

    constructor(props) {
        super(props);
        this.apiRoutes = {
            [route.PROPERTIES]() {
                props.getList(PROPERTY_API_URL)
            },
            [route.INSPECTION](startDate, endDate,inspectionIds) {
                if (startDate && endDate) {
                    props.getInspectionsByDate(INSPECTION_API_URL, startDate, endDate);
                }
                else if(inspectionIds){
                    props.getInspectionsByFilter(INSPECTION_API_URL,inspectionIds);
                }
                else {
                    props.getList(INSPECTION_API_URL);
                }
            },
            [route.ADMIN]() {
                props.getList(ADMIN_API_URL)
            },
            [route.AGENT]() {
                props.getList(AGENT_API_URL)
            },
            [route.CLERK]() {
                props.getList(CLERK_API_URL)
            },
            [route.REPORT]() {
                props.getList(REPORT_ACTIONS_API_URL)
            },
            [route.CUSTOMER_SERVICE](startDate, endDate) {
                if (startDate && endDate) {
                    props.getCustomerServiceByDate(CUSTOMER_SERVICE_API_URL, startDate, endDate);
                }
                else {
                    props.getList(CUSTOMER_SERVICE_API_URL)
                }
            },
            [route.PROPERTY_VISIT](startDate, endDate) {
                if (startDate && endDate) {
                    props.getPropertyVisitsByDate(PROPERTY_VISIT_API_URL, startDate, endDate);
                }
                else {
                    props.getList(PROPERTY_VISIT_API_URL)
                }},
        };
    }

    componentDidMount() {
        if(this.props.startDate && this.props.endDate){
            this.onRouteChange(this.props.startDate,this.props.endDate);
        }
        else if(this.props.inspectionIds) {
            this.onRouteChange(undefined,undefined,this.props.inspectionIds);
        }
        else {
            this.onRouteChange();
        }
        if (localStorage.getItem("user") && this.props.location.pathname != "/") {
            const user = JSON.parse(localStorage.getItem('user'));
            this.setState({ userRole: user['role'], userId: user["user_id"] });   
            this.props.getDashboardData(moment().add('-1', "month").startOf('month').format("DD-MM-YYYY"), moment().add('2', "month").endOf('month').format("DD-MM-YYYY"))
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChange(this.props.startDate,this.props.endDate,this.props.inspectionIds);
        }
    }

    render() {
        const adminNavItem = (
            <div className="navigation-header">
                <Menu size="mini" stackable pointing inverted>
                    <Menu.Header position="left">
                        <img src={logo} className="hinch-logo ui" alt="Hinch Logo" width="100%"/>
                    </Menu.Header>
                    <Menu.Menu position="right">
                        <Menu.Item name='dashboard' as={Link} to={route.HOME}
                                   active={this.props.location.pathname.indexOf('/dashboard') >= 0 || this.props.location.pathname === '/'}
                                   onClick={() => {
                                       this.setState({activeRoute: 'dashboard'})
                                   }}>
                            Dashboard
                        </Menu.Item>
                        <Dropdown item simple text="Property Visits">
                            <Dropdown.Menu>
                                <Dropdown.Item name='pv_schedule' as={Link} to={route.PROPERTY_VISIT}
                                    
                                    active={this.props.location.pathname.indexOf('/property_visit') >= 0 }
                            onClick={() => {
                                // this.props.setFilter("", moment().add('-1', "month").startOf('month').format("DD-MM-YYYY"), moment().add('2', "month").endOf('month').format("DD-MM-YYYY"))
                                this.props.setFilter("",moment().startOf("day").format("DD-MM-YYYY"),moment().endOf("day").format("DD-MM-YYYY"));

                                this.setState({ activeRoute: 'pv' })
                            }}>
                                    Property Visit Schedule
                                </Dropdown.Item>
                                <Dropdown.Item name='pv_create' as={Link} to={`${route.PROPERTY_VISIT}/create`}
                                    onClick={() => {
                                        this.setState({ activeRoute: 'pv' })
                                    }}>
                                    Add Property Visits
                                </Dropdown.Item>
                            </Dropdown.Menu>
                            </Dropdown>
                        <Dropdown item simple text="Forms">
                            <Dropdown.Menu>
                                <Dropdown.Item name='soc' as={Link} to={route.SCHEDULE_OF_CONDITIONS}
                                   onClick={() => {
                                       this.setState({activeRoute: 'soc'})
                                   }}>
                                    Schedule of Conditions
                                </Dropdown.Item>
                                <Dropdown.Item name='visual_elec' as={Link} to={route.VISUAL_ELEC}
                                    onClick={() => {
                                        this.setState({ activeRoute: 'visual_elec' })
                                    }}>
                                    Visual Electrical Checklist
                                </Dropdown.Item>
                                <Dropdown.Item name='expenses_generator' as={Link} to={route.EXPENSES_GENERATOR}
                                    onClick={() => {
                                        this.setState({ activeRoute: 'expenses_generator' })
                                    }}>
                                    Clerk Expenses
                                </Dropdown.Item>
                                <Dropdown.Item name='clerk_distribution' as={Link} to={route.CLERK_DISTRIBUTION}
                                    onClick={() => {
                                        this.setState({ activeRoute: 'clerk_distribution' })
                                    }}>
                                    Clerk Distribution
                                </Dropdown.Item>
                                <Dropdown.Item name='price_lists' as={Link} to={route.PRICE_LISTS}
                                    onClick={() => {
                                        this.setState({ activeRoute: 'price_lists' })
                                    }}>
                                    Price Lists
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown item simple text="Properties">
                                <Dropdown.Menu>
                                    <Dropdown.Item name='properties' as={Link} to={route.PROPERTIES}
                                        onClick={() => {
                                            this.setState({ activeRoute: 'properties' })
                                        }}>
                                        Property List
                                    </Dropdown.Item>
                                <Dropdown.Item name='properties' as={Link} to={`${route.PROPERTIES}/quicksearch`}
                                        onClick={() => {
                                            this.setState({ activeRoute: 'quicksearch' })
                                        }}>
                                        Quicksearch
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        <Menu.Item name='inspection' as={Link} to={route.INSPECTION}
                                   active={this.props.location.pathname.indexOf('/inspection') >= 0}
                                   onClick={() => {this.props.setFilter(undefined, moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), undefined)
                                       this.setState({activeRoute: 'inspection'})
                                   }}>
                            Inspections
                        </Menu.Item>
                        <Dropdown item simple text="Reports">
                            <Dropdown.Menu>
                                {/* <Dropdown.Item as={Link} to={route.REPORT} onClick={() => {
                                    this.setState({activeRoute: 'report'})
                                }}>View Reports</Dropdown.Item> */}
                                <Dropdown.Item as={Link} to={`${route.REPORT}/template/list`} onClick={() => {
                                    this.setState({activeRoute: 'report'})
                                }}>Report Templates</Dropdown.Item>
                                <Dropdown.Item as={Link} to={`${route.REPORT}/module`} onClick={() => {
                                    this.setState({activeRoute: 'report'})
                                }}>Report Modules</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        {/* <Dropdown item simple text="Accounts">
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to={route.INVOICE} onClick={() => {
                                    this.setState({activeRoute: 'account'})
                                }}>Invoices</Dropdown.Item>
                                <Dropdown.Item as={Link} to={route.REMITTANCE} onClick={() => {
                                    this.setState({activeRoute: 'account'})
                                }}>Remittance</Dropdown.Item>
                                <Dropdown.Item as={Link} to={route.EXPENSE} onClick={() => {
                                    this.setState({activeRoute: 'account'})
                                }}>Expenses</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> */}
                        <Menu.Item name='customer_service' as={Link} to={route.CUSTOMER_SERVICE}
                            active={this.props.location.pathname.indexOf('/customer_service') >= 0 }
                            onClick={() => {
                                this.props.setFilter("", moment().add('-1', "month").startOf('month').format("DD-MM-YYYY"), moment().add('2', "month").endOf('month').format("DD-MM-YYYY"))
                                this.setState({ activeRoute: 'customer_service' })
                            }}>
                            Customer Service
                            {this.props.dashboardData && this.props.dashboardData["cs_pending"] + this.props.dashboardData["cs_awaiting_admin_review"] > 0 && <Label color='olive' circular>{ this.props.dashboardData["cs_pending"] + this.props.dashboardData["cs_awaiting_admin_review"]}</Label>}
                        </Menu.Item>
                        <Dropdown item text='Users' simple>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to={route.ADMIN} onClick={() => {
                                    this.setState({activeRoute: 'admin'})
                                }}>Admin Users</Dropdown.Item>
                                <Dropdown.Item as={Link} to={route.AGENT} onClick={() => {
                                    this.setState({activeRoute: 'agent'})
                                }}>Agent</Dropdown.Item>
                                <Dropdown.Item as={Link} to={route.CLERK} onClick={() => {
                                    this.setState({activeRoute: 'clerk'})
                                }}>Clerk</Dropdown.Item>
                                <Dropdown.Item as={Link} to={route.COMPANY} onClick={() => {
                                    this.setState({activeRoute: 'company'})
                                }}>Company</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown item simple
                                  trigger={<span><Icon circular inverted color='olive' name='user' size='small'/>My Account</span>}>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to={route.ADMIN_PROFILE}><Icon
                                    name='user'/>Profile</Dropdown.Item>
                                <Dropdown.Item as={Link} to={route.SETTINGS}><Icon
                                    name='setting'/>Settings</Dropdown.Item>
                                <Dropdown.Item onClick={() => { Object.assign(document.createElement('a'), { target: '_blank', href: "https://www.hinchpm.com/clerk-training/" }).click() }}><Icon
                                name='question'/>Clerk Training</Dropdown.Item>
                                <Dropdown.Item name='signout' onClick={this.props.signOutAction}><Icon
                                    name='sign out'/>Signout</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Menu>
                </Menu>
            </div>
        );
        const agentNavItem = (
        <div className="navigation-header">
            <Menu stackable pointing inverted>
                <Menu.Header position="left">
                    <img src={logo} className="hinch-logo ui" alt="Hinch Logo" width="100%"/>
                </Menu.Header>

                <Menu.Menu position='right'>
                    <Menu.Item name='dashboard' as={Link} to={route.HOME}
                               active={this.props.location.pathname.indexOf('/dashboard') >= 0 || this.props.location.pathname === '/'}
                               onClick={() => {
                                   this.setState({activeRoute: 'dashboard'})
                               }}>
                        Dashboard
                    </Menu.Item>
                    <Menu.Item name='inspection' as={Link} to={route.INSPECTION}
                               active={this.props.location.pathname.indexOf('/inspection') >= 0 || this.props.location.pathname === '/inspection'}
                               onClick={() => {
                                   this.setState({activeRoute: 'inspection'})
                               }}>
                        Inspections
                    </Menu.Item>
                    <Menu.Item name='pv_schedule' as={Link} to={route.PROPERTY_VISIT}
                                    active={this.props.location.pathname.indexOf('/property_visit') >= 0 }
                            onClick={() => {
                                this.props.setFilter("", moment().add('-1', "month").startOf('month').format("DD-MM-YYYY"), moment().add('2', "month").endOf('month').format("DD-MM-YYYY"))
                                this.setState({ activeRoute: 'pv' })
                            }}>Property Visits</Menu.Item>
                    <Menu.Item name='properties' as={Link} to={route.PROPERTIES}
                               active={this.props.location.pathname.indexOf('/properties') >= 0}
                               onClick={() => {
                                   this.props.getList(PROPERTY_API_URL);
                                   this.setState({activeRoute: 'properties'})
                               }}>
                        Properties
                    </Menu.Item>
                    {/* <Dropdown item simple text="Accounts">
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to={route.INVOICE} onClick={() => {
                                this.setState({activeRoute: 'account'})
                            }}>Invoices</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
                    <Dropdown simple item
                              trigger={<span><Icon circular inverted color='olive' name='user' size='small'/>My Account</span>}>
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to={route.AGENT_PROFILE}><Icon name='user'/>Profile</Dropdown.Item>
                            <Dropdown.Item as={Link} to={route.SETTINGS}><Icon
                                name='setting'/>Settings</Dropdown.Item>
                            <Dropdown.Item name='signout' onClick={this.props.signOutAction}><Icon
                                name='sign out'/>Signout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Menu>
            </Menu>
        </div>
        );
        const clerkNavItem = (
            <React.Fragment>
        <div className="navigation-header">
            <Menu stackable pointing inverted>
                <Menu.Header position="left">
                    <img src={logo} className="hinch-logo ui" alt="Hinch Logo" width="100%"/>
                </Menu.Header>
                <Menu.Menu position='right'>
                    <Menu.Item name='dashboard' as={Link} to={route.HOME}
                               active={this.props.location.pathname.indexOf('/dashboard') >= 0 || this.props.location.pathname === '/'}
                               onClick={() => {
                                   this.setState({activeRoute: 'dashboard'})
                               }}>
                        Dashboard
                    </Menu.Item>
                    <Dropdown item simple text="Forms">
                            <Dropdown.Menu>
                                <Dropdown.Item name='soc' as={Link} to={route.SCHEDULE_OF_CONDITIONS}
                                   onClick={() => {
                                       this.setState({activeRoute: 'soc'})
                                   }}>
                                    Schedule of Conditions
                                </Dropdown.Item>
                                <Dropdown.Item name='visual_elec' as={Link} to={route.VISUAL_ELEC}
                                    onClick={() => {
                                        this.setState({ activeRoute: 'visual_elec' })
                                    }}>
                                    Visual Electrical Checklist
                                </Dropdown.Item>
                                <Dropdown.Item name='expenses_generator' as={Link} to={route.EXPENSES_GENERATOR}
                                    onClick={() => {
                                        this.setState({ activeRoute: 'expenses_generator' })
                                    }}>
                                    Clerk Expenses
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    <Menu.Item name='inspection' as={Link} to={route.INSPECTION}
                               active={this.props.location.pathname.indexOf('/inspection') >= 0}
                               onClick={() => {
                                   this.setState({activeRoute: 'inspection'})
                               }}>
                        Inspections
                            </Menu.Item>
                            <Menu.Item name='pv_schedule' as={Link} to={route.PROPERTY_VISIT}
                                    
                                    active={this.props.location.pathname.indexOf('/property_visit') >= 0 }
                            onClick={() => {
                                this.props.setFilter("", moment().add('-1', "month").startOf('month').format("DD-MM-YYYY"), moment().add('2', "month").endOf('month').format("DD-MM-YYYY"))
                                this.setState({ activeRoute: 'pv' })
                            }}>Property Visits{this.props.dashboardData && this.props.dashboardData["pv_scheduled"]> 0 && <Label color='olive' circular>{ this.props.dashboardData["pv_scheduled"]}</Label>}
                                </Menu.Item>
                    <Menu.Item name='customer_service' as={Link} to={route.CUSTOMER_SERVICE}
                            active={this.props.location.pathname.indexOf('/customer_service') >= 0 }
                            onClick={() => {
                                this.props.setFilter("", moment().add('-1', "month").startOf('month').format("DD-MM-YYYY"), moment().add('2', "month").endOf('month').format("DD-MM-YYYY"))
                                this.setState({ activeRoute: 'customer_service' })
                            }}>
                            Customer Service
                            {this.props.dashboardData && this.props.dashboardData["cs_awaiting_clerk_reply"] > 0 && <Label color='olive' circular>{ this.props.dashboardData["cs_awaiting_clerk_reply"]}</Label>}
                        </Menu.Item>
                    {/* <Menu.Item name='report' as={Link} to={route.REPORT}
                               active={this.props.location.pathname.indexOf('/report') >= 0}
                               onClick={() => {
                                   this.setState({activeRoute: 'report'})
                               }}>
                        Reports
                    </Menu.Item> */}
                    {/* <Dropdown item simple text="Accounts">
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to={route.REMITTANCE} onClick={() => {
                                this.setState({activeRoute: 'account'})
                            }}>Remittance</Dropdown.Item>
                            <Dropdown.Item as={Link} to={route.EXPENSE} onClick={() => {
                                this.setState({activeRoute: 'account'})
                            }}>Expenses</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
                    <Dropdown item simple
                              trigger={<span><Icon circular inverted color='olive' name='user' size='small'/>My Account</span>}>
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to={route.CLERK_PROFILE}><Icon name='user'/>Profile</Dropdown.Item>
                            <Dropdown.Item as={Link} to={route.SETTINGS}><Icon
                                name='setting'/>Settings</Dropdown.Item>
                            <Dropdown.Item onClick={() => { Object.assign(document.createElement('a'), { target: '_blank', href: "https://www.hinchpm.com/clerk-training/" }).click() }}><Icon
                                name='question'/>Clerk Training</Dropdown.Item>
                            <Dropdown.Item name='signout' onClick={this.props.signOutAction}><Icon
                                name='sign out'/>Signout</Dropdown.Item>
                        </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Menu>
                </Menu>
            </div>
                {this.props.dashboardData && this.props.dashboardData["cs_awaiting_clerk_reply_over_24h"].length > 0 &&
                    <div className='sticky-container-cs'>
                        <div className='sticky-container-cs-inner'>
                            <Message size="large" negative>
                                <Message.Header>You have {this.props.dashboardData["cs_awaiting_clerk_reply_over_24h"].length} Customer Service {this.props.dashboardData["cs_awaiting_clerk_reply_over_24h"].length > 1? "Queries" : "Query"} awaiting a reply for over 24 Hours, please submit a response as soon as possible</Message.Header>
                            </Message></div></div>}
            </React.Fragment>
        );
        let CurrentUserNavBar = adminNavItem;
        if (this.props.userRole === 'admin') {
            CurrentUserNavBar = adminNavItem;
        } else if (this.props.userRole === 'agent') {
            CurrentUserNavBar = agentNavItem;
        } else if (this.props.userRole === 'clerk') {
            CurrentUserNavBar = clerkNavItem;
        } else {
            return null;
        }
        return this.props.authenticated && CurrentUserNavBar;
    }
}


export default withRouter(FilterAttributes(ListingContainer(DashboardContainer(InspectionContainer(AuthConnector(Header))))));


// WEBPACK FOOTER //
// ./src/views/universal/header.js